webpackJsonp([248116827846889],{

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Philippe-DeRyck.944b4788.jpg";

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PhilippeDeRyck = __webpack_require__(52);
	
	var _PhilippeDeRyck2 = _interopRequireDefault(_PhilippeDeRyck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhilippeDeRyckWorkshop = function PhilippeDeRyckWorkshop() {
	    return _react2.default.createElement(
	        'section',
	        { id: 'speaker', className: 'parallax-section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'team-wrapper' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Workshop: A builder\'s guide to API security by Philippe De Ryck'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Date: Thursday, 26 March'
	                        ),
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'The Place: Wantsome, The Friendly IT Academy, Centris Building, Colonel Langa 17, Ia\u0219i'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4' },
	                                _react2.default.createElement('img', { src: _PhilippeDeRyck2.default, className: 'img-responsive', alt: 'Philippe De Ryck' }),
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'social-icon' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/philippederyck/', target: '_blank', className: 'fa fa-linkedin wow fadeIn', 'data-wow-delay': '0.3s' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        _react2.default.createElement('a', { href: 'https://twitter.com/philippederyck', target: '_blank', className: 'fa fa-twitter wow fadeIn', 'data-wow-delay': '0.6s' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-7' },
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    'Philippe De Ryck helps developers protect companies through better web security. As the founder of Pragmatic Web Security, he travels the world to train developers on web security and security engineering. ',
	                                    _react2.default.createElement('br', null),
	                                    'His Ph.D. in web security from KU Leuven lies at the basis of his exceptional knowledge of the security landscape. Google recognizes Philippe as a Google Developer Expert for his work on security in Angular applications.'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Schedule'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement('br', null),
	                                '08:30 - 09:00 - Registration',
	                                _react2.default.createElement('br', null),
	                                '09:00 - 13:00 -  Workshop',
	                                _react2.default.createElement('br', null),
	                                '13:00 - 14:00 - Lunch',
	                                _react2.default.createElement('br', null),
	                                '14:00 - 18:00 - Workshop',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'About the workshop'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Most modern applications consist of a frontend web or mobile application, backed by several API-based services. This paradigm shift from server-side page generation causes a significant impact on various security aspects. To build secure applications, developers need to be aware of these security changes, along with current best practices.',
	                                _react2.default.createElement('br', null),
	                                'This one-day workshop offers a unique in-depth perspective on modern API security.',
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'list-group list-group-flush row' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'list-group-item list-group-item-coloured col-xs-12' },
	                                        'API authentication'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'list-group-item list-group-item-coloured col-xs-12' },
	                                        'Managing "sessions"'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'list-group-item list-group-item-coloured col-xs-12' },
	                                        'Securely handling JSON Web Tokens'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'list-group-item list-group-item-coloured col-xs-12' },
	                                        'Understanding and securing Cross-Origin Resource Sharing (CORS)'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'list-group-item list-group-item-coloured col-xs-12' },
	                                        'Custom-built offensive and defensive lab assignments'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Prerequisites'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Experience with developing web-facing APIs.',
	                                _react2.default.createElement('br', null),
	                                'A laptop with a modern browser (e.g., Chrome, Firefox) installed.'
	                            ),
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                'Target audience'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Anyone who is concerned about building secure APIs.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content row', id: 'tickets' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'plans' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'plan' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        { className: 'plan-title' },
	                                        'Workshop ',
	                                        _react2.default.createElement('br', null),
	                                        'Early bird'
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'plan-features' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                '9 December - 19 January'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'plan-price' },
	                                        '\u20AC350'
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'plan-features' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'VAT NOT included'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-info btn-tickets disabled', href: '#', target: '_blank' },
	                                        ' Sold out '
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'plan plan-tall' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        { className: 'plan-title' },
	                                        'Workshop ',
	                                        _react2.default.createElement('br', null),
	                                        'Normal'
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'plan-features' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                '20 January - 8 March'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'plan-price' },
	                                        '\u20AC400'
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'plan-features' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'VAT NOT included'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-info btn-tickets', href: 'https://forms.gle/QUouQAUX5LvEi9r89', target: '_blank' },
	                                        ' Register '
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'plan' },
	                                    _react2.default.createElement(
	                                        'h2',
	                                        { className: 'plan-title' },
	                                        'Workshop ',
	                                        _react2.default.createElement('br', null),
	                                        'Late bird'
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'plan-features' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'strong',
	                                                null,
	                                                '8 March - 25 March'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'plan-price' },
	                                        '\u20AC450'
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'plan-features' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            'VAT NOT included'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'btn btn-info btn-tickets disabled', href: '#', target: '_blank' },
	                                        ' Not available '
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = PhilippeDeRyckWorkshop;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-workshops-api-security-js-2ad013549ac28e551d67.js